import moment from 'moment-timezone'

export function pickerDate (daysAgo = 0) {
  const [year, month, day] = moment().tz('Asia/Bangkok').subtract(daysAgo, 'days').format('YYYY-MM-DD').split('-').map(Number)
  return new Date(year, month - 1, day)
}
export function dateKey (value) {
  const parsed = value instanceof Date ? moment(value) : moment(value, ['YYYY-MM-DD', 'DD MMM YYYY'], true)
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : ''
}
export function selectedRange (start, end) {
  const from = dateKey(start), to = dateKey(end)
  return from && to && from <= to ? { start: from, end: to } : null
}

// Vuex state is the request owner. A change or route teardown invalidates an
// earlier response, even if the HTTP requests complete in the opposite order.
const generations = new WeakMap()
export function invalidateReport (state) {
  const generation = (generations.get(state) || 0) + 1
  generations.set(state, generation)
  return generation
}
export function currentReport (state, generation) { return generations.get(state) === generation }

export function createRangeLoader ({ invalidate, loading, error, load }) {
  let generation = 0, timer = null, stopped = false
  const run = async (range, request) => {
    try { await load(range) } catch (_) {
      if (!stopped && generation === request) error('โหลดรายงานไม่สำเร็จ กรุณาลองอีกครั้ง')
    } finally {
      if (!stopped && generation === request) loading(false)
    }
  }
  return {
    schedule (start, end, immediate = false) {
      const request = ++generation
      clearTimeout(timer); invalidate(); error('')
      const range = selectedRange(start, end)
      if (!range) { loading(false); error('กรุณาเลือกวันเริ่มต้นไม่เกินวันสิ้นสุด'); return }
      loading(true)
      if (immediate) return run(range, request)
      timer = setTimeout(() => run(range, request), 200)
    },
    stop () { stopped = true; generation++; clearTimeout(timer); invalidate() }
  }
}
